module.exports = __webpack_public_path__ + "static/media/chandizhengshenqingliucheng5.b0c1acc8.png";